import { useEffect, useState } from 'react'
import type { KeyValue } from '@viewer/lib/ifcItemData'
import { type Unidade, type UnidadeDaPropriedade, unidadeDaPropriedade } from '@viewer/lib/unidades'
import { obterUnidadesDoProjecto, unidadePropria } from '@viewer/lib/unidadesDoModelo'

/** A função que dá a unidade de uma linha de propriedade, para o modelo
 *  pedido. Lê as unidades do projecto uma vez por modelo; até chegarem,
 *  devolve null e os valores aparecem sem unidade. */
export function useUnidadeDe(modelId: string | null): (row: KeyValue) => UnidadeDaPropriedade | null {
  const [carga, setCarga] = useState<{
    modelId: string
    porTipo: Map<string, Unidade>
    ambiguas: Map<string, Unidade[]>
  } | null>(null)
  useEffect(() => {
    if (!modelId) return
    let vivo = true
    void obterUnidadesDoProjecto(modelId).then((u) => {
      if (vivo && u) setCarga({ modelId, porTipo: u.porTipo, ambiguas: u.ambiguas })
    })
    return () => {
      vivo = false
    }
  }, [modelId])
  return (row: KeyValue) => {
    if (!modelId || carga?.modelId !== modelId) return null
    return unidadeDaPropriedade(row.medida, unidadePropria(modelId, row.localId), carga.porTipo, carga.ambiguas)
  }
}
